import {
  NOTE_PREVIEW_PAPER_PADDING_PX,
  NOTE_PREVIEW_TEXT_COLOR,
} from "../note-preview-constant";
import { NotePreviewSection, NotePreviewView } from "../note-preview-types";
import NotePreviewSectionBlock from "./NotePreviewSectionBlock";
import ReportFooter from "./ReportFooter";
import ReportPatientDetails from "./ReportPatientDetails";
import ReportAddendumBlock from "./ReportAddendumBlock";
import ReportPracticeHeader from "./ReportPracticeHeader";
import ReportSignatureBlock from "./ReportSignatureBlock";

export interface NotePreviewDocumentProps {
  view: NotePreviewView;
  sections: NotePreviewSection[];
}

/** The report paper, shared by the on-screen preview and the PDF capture. */
const NotePreviewDocument = ({ view, sections }: NotePreviewDocumentProps) => (
  <article
    style={{
      position: "relative",
      background: "#FFFFFF",
      padding: NOTE_PREVIEW_PAPER_PADDING_PX,
      fontFamily: "inherit",
      color: NOTE_PREVIEW_TEXT_COLOR,
    }}
  >
    <ReportPracticeHeader practice={view.practice} />
    <ReportPatientDetails patient={view.patient} visitLine={view.title} />
    {sections.map((section) => (
      <NotePreviewSectionBlock key={section.key} section={section} />
    ))}
    <ReportSignatureBlock signature={view.signature} />
    {view.addendum && <ReportAddendumBlock addendum={view.addendum} />}
    <ReportFooter footer={view.footer} />
  </article>
);

export default NotePreviewDocument;
